/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .max(
      50,
      i18n.t('MAX_LENGTH_KEY', {
        value: 50,
      })
    ),
  url: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
});
